import React from "react";
import "./Programs.css";
import { programsData } from "../../data/programsData";
import RightArrow from "../../assets/rightArrow.png";

const Programs = () => {
  return (
    <div className="programs" id="programs">
      <div className="programs-header">
        <span className="stroke-text-filled">Explore our</span>
        <span className="filled-text">Programs</span>
        <span className="stroke-text-filled">To shape you</span>
      </div>

      <div className="programs-categories">
        {programsData.map((program, index) => (
          <div className="category-card" key={index}>
            <div className="icon">{program.image}</div>
            <h3>{program.heading}</h3>
            <p>{program.details}</p>
            <div className="join-now">
              <span>Join Now</span>
              <img src={RightArrow} alt="Right Arrow" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Programs;
